// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"587":"9074192a962c407675a8","3191":"cdd5aaaed0f3c3cc8f44"}[chunkId] + ".chunk.css";
};